class BestSellers extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (typeof Swiper === "undefined") {
      console.error("Swiper is not loaded!");
      return;
    }

    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.closest('.swiper'), {
      slidesPerView: 3,
      spaceBetween: 18,
      centeredSlides: true,
      loop: true,
      grabCursor: true,
      speed: 600,

      breakpoints: {
        0: {
          slidesPerView: 1.37,
          centeredSlides: true,
          spaceBetween: 18,
        },
        500: {
          slidesPerView: 1.8,
          spaceBetween: 18,
        },
        768: {
          slidesPerView: 2.6,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: true,
          spaceBetween: 32,
        }
      }
    });
  }
}

customElements.define("best-sellers", BestSellers);
